/* Three Vikings — theme.js */
(function () {
  'use strict';

  const money = (cents) => {
    const format = (window.Shopify && Shopify.formatMoney) ? null : null;
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  };

  /* ——— CART ——— */
  const Cart = {
    state: { item_count: 0, items: [], total_price: 0 },
    listeners: [],
    subscribe(fn) { this.listeners.push(fn); fn(this.state); },
    emit() { this.listeners.forEach(fn => fn(this.state)); },
    async fetch() {
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }});
        this.state = await r.json();
        this.emit();
      } catch (e) { console.error('Cart fetch failed', e); }
      return this.state;
    },
    async add(id, qty) {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      });
      if (!r.ok) { throw new Error((await r.json()).description || 'Add failed'); }
      await this.fetch();
      return r.json();
    },
    async change(line, quantity) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      if (!r.ok) { throw new Error('Change failed'); }
      this.state = await r.json();
      this.emit();
      return this.state;
    }
  };
  window.Cart = Cart;

  /* ——— CART DRAWER ——— */
  function initCartDrawer() {
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-overlay');
    if (!drawer || !overlay) return;
    const open = () => { drawer.classList.add('open'); overlay.classList.add('open'); document.body.style.overflow = 'hidden'; };
    const close = () => { drawer.classList.remove('open'); overlay.classList.remove('open'); document.body.style.overflow = ''; };
    window.openCart = open;
    window.closeCart = close;
    overlay.addEventListener('click', close);
    drawer.querySelector('.close')?.addEventListener('click', close);
    drawer.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', close));
    document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', (e) => { e.preventDefault(); open(); }));

    Cart.subscribe(render);
    function render(state) {
      const body = drawer.querySelector('.cart-body');
      const foot = drawer.querySelector('.cart-foot');
      const title = drawer.querySelector('.cart-head h3');
      if (!body) return;
      if (title) title.textContent = state.item_count > 0 ? `Your cart (${state.item_count})` : 'Your cart';

      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = state.item_count;
        el.style.display = state.item_count > 0 ? '' : 'none';
      });

      if (!state.items || state.items.length === 0) {
        body.innerHTML = `
          <div class="cart-empty">
            <div class="ico">${iconBag(28)}</div>
            <h4>Empty, for now.</h4>
            <p style="font-size:14px;max-width:260px">Add a spool of the Field Cord and we'll ship it Monday.</p>
            <button type="button" class="btn btn-primary" data-cart-close>Shop the cord</button>
          </div>`;
        if (foot) foot.style.display = 'none';
        body.querySelector('[data-cart-close]')?.addEventListener('click', close);
        return;
      }

      body.innerHTML = state.items.map((it, i) => `
        <div class="cart-item" data-line="${i + 1}">
          <div class="ci-media">${it.image ? `<img src="${it.image}" alt="${escapeHtml(it.product_title)}" loading="lazy">` : `<div class="ph-product"><div class="spool"></div></div>`}</div>
          <div>
            <div class="ci-title">${escapeHtml(it.product_title)}</div>
            <div class="ci-opts">${escapeHtml((it.variant_options || []).join(' · '))}</div>
            <div class="ci-qty">
              <button type="button" data-change="-1" aria-label="Decrease">${iconMinus(12)}</button>
              <span class="n">${it.quantity}</span>
              <button type="button" data-change="1" aria-label="Increase">${iconPlus(12)}</button>
            </div>
          </div>
          <div class="ci-right">
            <div class="ci-price">${money(it.final_line_price)}</div>
            <button type="button" class="ci-remove" data-remove>Remove</button>
          </div>
        </div>
      `).join('');

      body.querySelectorAll('.cart-item').forEach((el) => {
        const line = parseInt(el.dataset.line, 10);
        const item = state.items[line - 1];
        el.querySelector('[data-change="-1"]').addEventListener('click', () => Cart.change(line, item.quantity - 1));
        el.querySelector('[data-change="1"]').addEventListener('click', () => Cart.change(line, item.quantity + 1));
        el.querySelector('[data-remove]').addEventListener('click', () => Cart.change(line, 0));
      });

      if (foot) {
        foot.style.display = '';
        const threshold = parseInt(foot.dataset.freeThreshold || '7500', 10);
        const toFree = Math.max(0, threshold - state.total_price);
        const note = foot.querySelector('.cart-ship-note');
        if (note) {
          note.classList.toggle('unlock', toFree === 0);
          note.textContent = toFree === 0 ? '✓ Free U.S. shipping on every order' : `Add ${money(toFree)} for free U.S. shipping`;
        }
        foot.querySelector('[data-cart-subtotal]').textContent = money(state.total_price);
        const shipEl = foot.querySelector('[data-cart-shipping]');
        if (shipEl) shipEl.textContent = state.total_price >= threshold ? 'Free' : money(600);
        foot.querySelector('[data-cart-total]').textContent = money(state.total_price + (state.total_price >= threshold ? 0 : 600));
      }
    }
  }

  /* ——— PRODUCT FORM ——— */
  function initProductForm() {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      const data = JSON.parse(form.dataset.product || '{}');
      const variants = data.variants || [];
      const colorIndex = parseInt(form.dataset.colorIndex || '0', 10);
      const priceEl = form.querySelector('[data-price-now]');
      const wasEl = form.querySelector('[data-price-was]');
      const idInput = form.querySelector('[name="id"]');
      const submitBtn = form.querySelector('[data-add]');
      const qtyInput = form.querySelector('[name="quantity"]');
      const captionOpts = form.querySelector('[data-caption-opts]');
      const captionLot = form.querySelector('[data-caption-lot]');
      const mediaSpool = form.querySelector('.buybox-media .spool');
      const tagEl = form.querySelector('.buybox-media .tag');
      const mainImg = form.querySelector('[data-main-image]');
      const mainPlaceholder = form.querySelector('[data-main-placeholder]');
      const gallery = form.querySelector('[data-gallery]');
      const allThumbs = gallery ? Array.from(gallery.querySelectorAll('[data-gal-thumb]')) : [];
      const track = gallery ? gallery.querySelector('.gal-track') : null;
      const prevBtn = gallery ? gallery.querySelector('[data-gal-prev]') : null;
      const nextBtn = gallery ? gallery.querySelector('[data-gal-next]') : null;

      let visibleThumbs = allThumbs.slice();
      let currentIndex = 0;

      const variantImageMap = {};
      variants.forEach(v => {
        if (v.featured_image && v.featured_image.src) {
          variantImageMap[v.id] = v.featured_image.src;
        }
      });

      const showMainImage = (src, alt) => {
        if (!mainImg) return;
        if (src) {
          mainImg.hidden = false;
          mainImg.src = src;
          if (alt) mainImg.alt = alt;
          if (mainPlaceholder) mainPlaceholder.style.display = 'none';
        } else if (mainPlaceholder) {
          mainImg.hidden = true;
          mainPlaceholder.style.display = '';
        }
      };

      const setActiveThumb = (thumb) => {
        allThumbs.forEach(t => t.classList.remove('active'));
        if (thumb) thumb.classList.add('active');
      };

      const scrollThumbIntoView = (thumb) => {
        if (!thumb) return;
        const wrap = gallery && gallery.querySelector('.gal-track-wrap');
        if (!wrap) return;
        const target = thumb.offsetLeft - (wrap.clientWidth / 2) + (thumb.offsetWidth / 2);
        wrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
      };

      const updateArrows = () => {
        if (!prevBtn || !nextBtn) return;
        const multi = visibleThumbs.length > 1;
        prevBtn.disabled = !multi;
        nextBtn.disabled = !multi;
        prevBtn.style.visibility = visibleThumbs.length === 0 ? 'hidden' : '';
        nextBtn.style.visibility = visibleThumbs.length === 0 ? 'hidden' : '';
      };

      const showThumbAt = (idx) => {
        if (visibleThumbs.length === 0) return;
        currentIndex = ((idx % visibleThumbs.length) + visibleThumbs.length) % visibleThumbs.length;
        const thumb = visibleThumbs[currentIndex];
        showMainImage(thumb.dataset.full, thumb.querySelector('img')?.alt);
        setActiveThumb(thumb);
        scrollThumbIntoView(thumb);
      };

      const filterGalleryByColor = (color, variantId) => {
        if (!gallery) return;
        const norm = (s) => (s || '').trim();
        const target = norm(color);
        let matching = allThumbs.filter(t => {
          const list = (t.dataset.colors || '').split('|').map(norm).filter(Boolean);
          return target && list.includes(target);
        });
        if (matching.length === 0) matching = allThumbs.slice();

        allThumbs.forEach(t => {
          t.style.display = matching.includes(t) ? '' : 'none';
        });
        visibleThumbs = matching;

        let startIdx = 0;
        const variantSrc = variantImageMap[variantId];
        if (variantSrc) {
          const idx = visibleThumbs.findIndex(t => t.dataset.full === variantSrc || (t.querySelector('img') && t.querySelector('img').src === variantSrc));
          if (idx >= 0) startIdx = idx;
        }
        showThumbAt(startIdx);
        updateArrows();
      };

      const getSelection = () => {
        const sel = {};
        form.querySelectorAll('[data-option-index]').forEach(group => {
          const idx = group.dataset.optionIndex;
          const active = group.querySelector('.swatch.active');
          sel[idx] = active ? active.dataset.value : null;
        });
        return sel;
      };

      const findVariant = (sel) => {
        return variants.find(v => {
          return ['option1', 'option2', 'option3'].every((k, i) => {
            const need = sel[String(i + 1)];
            return !need || v[k] === need;
          });
        });
      };

      // Recompute each swatch's availability against the OTHER currently-selected options
      const optionGroups = Array.from(form.querySelectorAll('[data-option-index]'));
      const updateAvailability = (sel) => {
        optionGroups.forEach(group => {
          const p = parseInt(group.dataset.optionIndex, 10);
          group.querySelectorAll('.swatch').forEach(btn => {
            const val = btn.dataset.value;
            const ok = variants.some(v => {
              if (v['option' + p] !== val) return false;
              for (let i = 1; i <= 3; i++) {
                if (i === p) continue;
                const need = sel[String(i)];
                if (need && v['option' + i] !== need) return false;
              }
              return v.available;
            });
            btn.classList.toggle('sold-out', !ok);
            btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
          });
        });
      };

      const update = () => {
        const sel = getSelection();
        updateAvailability(sel);
        const v = findVariant(sel);
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (wasEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            wasEl.textContent = money(v.compare_at_price);
            wasEl.style.display = '';
          } else {
            wasEl.style.display = 'none';
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !v.available;
          const labelEl = submitBtn.querySelector('[data-add-label]');
          if (labelEl) labelEl.textContent = v.available ? 'Add to cart' : 'Notify me';
        }
        if (tagEl) tagEl.textContent = v.available ? 'In stock' : 'Backorder';
        if (captionOpts) captionOpts.textContent = [v.option1, v.option2, v.option3].filter(Boolean).join(' · ');
        if (captionLot && v.metafields && v.metafields.lot_number) captionLot.textContent = 'LOT ' + v.metafields.lot_number;
        if (mediaSpool) {
          const colorMap = { 'Ember': '#d4581f', 'Ink': '#1a1a1a', 'Pine': '#2d4a3e', 'Bone': '#f5f1ea' };
          const hex = colorMap[sel['1']] || '#d4581f';
          mediaSpool.style.setProperty('--spool-color', hex);
        }
        form.querySelectorAll('[data-selected-color]').forEach(el => el.textContent = sel['1'] || '');
        form.querySelectorAll('[data-selected-length]').forEach(el => el.textContent = sel['2'] || '');

        const selectedColor = colorIndex > 0 ? sel[String(colorIndex)] : null;
        filterGalleryByColor(selectedColor, v.id);
      };

      allThumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = visibleThumbs.indexOf(thumb);
          if (idx >= 0) showThumbAt(idx);
        });
      });
      prevBtn?.addEventListener('click', (e) => { e.preventDefault(); showThumbAt(currentIndex - 1); });
      nextBtn?.addEventListener('click', (e) => { e.preventDefault(); showThumbAt(currentIndex + 1); });

      form.querySelectorAll('.swatch').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.classList.contains('sold-out')) return;
          const group = btn.closest('[data-option-index]');
          group.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
          btn.classList.add('active');
          update();
        });
      });

      form.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
      form.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      });

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (submitBtn.disabled) return;
        submitBtn.disabled = true;
        try {
          await Cart.add(idInput.value, parseInt(qtyInput.value, 10) || 1);
          window.openCart && window.openCart();
        } catch (err) {
          alert(err.message || 'Unable to add to cart');
        } finally {
          submitBtn.disabled = false;
        }
      });

      update();
    });
  }

  /* ——— STICKY BUY BAR ——— */
  function initStickyBuy() {
    const bar = document.querySelector('.sticky-buy');
    if (!bar) return;
    const hero = document.querySelector('.hero');
    const footer = document.querySelector('.footer');
    const onScroll = () => {
      if (!hero) return;
      const heroBottom = hero.getBoundingClientRect().bottom;
      const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
      const visible = heroBottom < 0 && footerTop > window.innerHeight;
      bar.classList.toggle('visible', visible);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    bar.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      document.getElementById('product')?.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ——— FAQ ——— */
  function initFAQ() {
    document.querySelectorAll('.faq').forEach(faq => {
      const items = faq.querySelectorAll('.faq-item');
      items.forEach(item => {
        item.querySelector('.faq-q')?.addEventListener('click', () => {
          const wasOpen = item.classList.contains('open');
          items.forEach(i => i.classList.remove('open'));
          if (!wasOpen) item.classList.add('open');
        });
      });
    });
  }

  /* ——— REVIEWS CAROUSEL ——— */
  function initReviewsCarousel() {
    document.querySelectorAll('[data-reviews]').forEach(wrap => {
      const track = wrap.querySelector('.review-track');
      const cards = track.querySelectorAll('.review-card');
      const perView = parseInt(wrap.dataset.perView || '3', 10);
      const pagesCount = Math.ceil(cards.length / perView);
      const pips = wrap.querySelector('.review-pips');
      const prev = wrap.querySelector('[data-prev]');
      const next = wrap.querySelector('[data-next]');
      let page = 0;

      if (pips) {
        pips.innerHTML = '';
        for (let i = 0; i < pagesCount; i++) {
          const d = document.createElement('div');
          d.className = 'pip' + (i === 0 ? ' active' : '');
          d.addEventListener('click', () => { page = i; apply(); });
          pips.appendChild(d);
        }
      }

      const apply = () => {
        track.style.transform = `translateX(calc(-${page * 100}% - ${page * 20}px))`;
        if (prev) prev.disabled = page === 0;
        if (next) next.disabled = page >= pagesCount - 1;
        pips?.querySelectorAll('.pip').forEach((p, i) => p.classList.toggle('active', i === page));
      };

      prev?.addEventListener('click', () => { page = Math.max(0, page - 1); apply(); });
      next?.addEventListener('click', () => { page = Math.min(pagesCount - 1, page + 1); apply(); });
      apply();
    });
  }

  /* ——— NEWSLETTER (inline success state) ——— */
  function initNewsletter() {
    document.querySelectorAll('.newsletter').forEach(sec => {
      const form = sec.querySelector('form');
      if (!form) return;
      if (sec.dataset.posted === '1') {
        const h = sec.querySelector('h2');
        const p = sec.querySelector('p');
        if (h) h.innerHTML = 'New colors, noted.';
        if (p) p.textContent = "You're on the list. We'll write when we have something worth saying.";
        form.style.display = 'none';
      }
    });
  }

  /* ——— ICONS ——— */
  function iconBag(size=16){return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 7h14l-1.2 13H6.2L5 7Z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>`;}
  function iconPlus(size=16){return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>`;}
  function iconMinus(size=16){return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>`;}
  function escapeHtml(s){return String(s||'').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}

  /* ——— BOOT ——— */
  document.addEventListener('DOMContentLoaded', () => {
    initCartDrawer();
    initProductForm();
    initStickyBuy();
    initFAQ();
    initReviewsCarousel();
    initNewsletter();
    Cart.fetch();
  });
})();
